import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TooltipMiddle from './Basic/TooltipMiddle';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    cursor: 'pointer',
  },
}));

const TooltipEnclosureMiddle = ({
  className = '',
  children = '',
  title = '',
  tooltipProps = {},
  ...restProps
}) => {
  const classes = useStyles();

  return (
    <TooltipMiddle title={title} {...tooltipProps}>
      <div className={`${classes.root} ${className}`} {...restProps}>
        {children}
      </div>
    </TooltipMiddle>
  );
};

export default TooltipEnclosureMiddle;
